import { withSentry } from './modules/sentry';
import $dom from 'cash-dom';
import modernizr from './lib/modernizr';
import account from './modules/account';
import lazySizes from 'lazysizes';
import objectFitPollyfill from './modules/objectFitPollyfill';
import 'lazysizes/plugins/bgset/ls.bgset';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import {
  globalEventBus,
  globalEventBusPlugin,
  globalStorePlugin
} from '@pixelcabin/ui-utils/lib/vue';

import { flyoutCart, flyoutCartStore } from './components/FlyoutCart/store';

import FlyoutCart from './components/FlyoutCart/FlyoutCart.vue';
import FlyoutCartBadge from './components/FlyoutCart/FlyoutCartBadge.vue';
import searchMini from './modules/search_mini';
import mainNavigation from './modules/main_navigation';
import stickyToolbar from './modules/sticky_toolbar';
import passwordAuth from './modules/password_auth';
import productVideo from './modules/product_video';
import emailCapture from './modules/email_capture';
import multiCurrencySelector from './modules/multi_currency_selector';

$dom.fn.ready(
  withSentry(() => {
    console.log(`initializing scripts for: ${__SHOPIFY_ENV__}`);
    modernizr();
    lazySizes.init();
    objectFitPollyfill();
    account();
    mainNavigation();
    searchMini();
    stickyToolbar();
    passwordAuth();
    emailCapture();

    $dom('[data-flyout-cart-toggle]').on('click', () => {
      globalEventBus.emit('flyoutCart.toggle');
    });

    Vue.use(vueCustomElement);
    Vue.use(globalEventBusPlugin);
    Vue.use(globalStorePlugin, [[flyoutCart, flyoutCartStore]]);

    Vue.customElement('pxl-flyout-cart', FlyoutCart);
    Vue.customElement('pxl-flyout-cart-badge', FlyoutCartBadge);

    if (!window.Modernizr.picture || !window.Modernizr.srcset) {
      import(/* webpackChunkName: "picturefill" */ 'picturefill').then(
        ({ default: picturefill }) => {
          picturefill();
        }
      );
    }

    if (__SHOPIFY_ENV__ === 'ibc') {
      productVideo();
    }

    if (__SHOPIFY_ENV__ === 'myflavia') {
      console.log('Ready to flave it up?');
      multiCurrencySelector();
    }
  })
);
